export const generateUuid = (): string => {
  if (typeof crypto !== 'undefined') {
    if ('randomUUID' in crypto && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID()
    }

    if ('getRandomValues' in crypto && typeof crypto.getRandomValues === 'function') {
      const bytes = new Uint8Array(16)
      crypto.getRandomValues(bytes)

      // RFC 4122 version 4
      bytes[6] = (bytes[6] & 0x0f) | 0x40
      bytes[8] = (bytes[8] & 0x3f) | 0x80

      const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
      return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
    }
  }

  // Last-resort fallback: keep app functioning, but may not satisfy strict UUID validators.
  return `${Date.now().toString(16).padStart(8, '0')}-${Math.random().toString(16).slice(2, 6).padEnd(4, '0')}-4000-8000-${Math.random().toString(16).slice(2, 14).padEnd(12, '0')}`
}
